import { Controller } from "@hotwired/stimulus"

// Drives the navbar search panel: switches the form action + placeholder
// between contexts (compounds / documents / source docs), remembers the last
// context in localStorage, and focuses the input when the panel opens.
export default class extends Controller {
  static targets = ["input", "form", "segButton"]
  static values = { contexts: Object }

  static STORAGE_KEY = "factory-search-context"

  connect() {
    this.applyContext(this.storedContext())
    this.onShown = () => this.inputTarget.focus()
    this.element.addEventListener("shown.bs.collapse", this.onShown)
  }

  disconnect() {
    this.element.removeEventListener("shown.bs.collapse", this.onShown)
  }

  select(event) {
    const ctx = event.currentTarget.dataset.ctx
    this.applyContext(ctx)
    this.store(ctx)
    this.inputTarget.focus()
  }

  applyContext(requested) {
    const key = this.contextsValue[requested] ? requested : this.firstKey()
    const conf = this.contextsValue[key]
    this.formTarget.setAttribute("action", conf.action)
    this.inputTarget.setAttribute("placeholder", conf.placeholder)
    this.segButtonTargets.forEach((b) => b.classList.toggle("active", b.dataset.ctx === key))
  }

  firstKey() {
    return Object.keys(this.contextsValue)[0]
  }

  storedContext() {
    try {
      return localStorage.getItem(this.constructor.STORAGE_KEY) || this.firstKey()
    } catch (e) {
      return this.firstKey()
    }
  }

  store(ctx) {
    try {
      localStorage.setItem(this.constructor.STORAGE_KEY, ctx)
    } catch (e) {
      /* ignore (private mode / disabled storage) */
    }
  }
}
